import PropTypes from 'prop-types';
import { MODULES, PSEUDO_MODULES } from 'react/signups/card/recipes/constants';

const currentModuleShape = PropTypes.oneOf(
  Object.values(MODULES).concat(Object.values(PSEUDO_MODULES)),
);

export default currentModuleShape;
